module.exports = __webpack_public_path__ + "img/442130e.png";